<template>
  <div>
    <v-container>
      <v-container>
        <h1>Rapporter</h1>

        <!-- Tabs header -->
        <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab>Enstaka Undersökningar</v-tab>
          <v-tab>Repeterande Undersökningar</v-tab>
        </v-tabs>

        <!-- Tab content -->
        <v-tabs-items v-model="tab" class="mt-5" @change="onTabChanged">
          <v-tab-item>
            <!-- Första tabben: SurveysInstancesTable -->
            <v-row>
              <v-col>
                <SurveysInstancesTable @selectSurveyInstance="surveInstanceChoosen" />
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <!-- Andra tabben: annan komponent/tabell -->
            <v-row>
              <v-col>
                <SurveysInstancesTableLinear
                  @selectSurveyInstance="surveInstanceChoosen"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-container>

      <!-- ====[The table with Servey Instances to select from]====== -->

      <!-- ====[Waiting Spinner]===================================== -->
      <div v-if="waiting">
        <div class="spinner spinner-border" style=""></div>
      </div>
      <!-- ====[The Report Graphs area]============================== -->
      <v-row>
        <v-col>
          <v-card class="elevation-3">
            <div v-if="reportToShow">
              <div>
                <v-divider class="mb-5"></v-divider>
                <!-- ====[The CSV image]============================= -->
                <div class="image-container">
                  <v-img
                    alt="Csv file"
                    class="shrink mr-2"
                    contain
                    src="../assets/downloadCsv.png"
                    transition="scale-transition"
                    width="40"
                    position="top"
                    @click.stop="fetchCsvFile()"
                  />
                </div>
                <!-- ====[The Filter Selection area]================= -->
                <h3 class="mb-5 ml-10">Välj filter för jämförelse</h3>
                <v-row align="start">
                  <!-- Dropdown -->
                  <v-col cols="4">
                    <v-select
                      v-model="filterToUse"
                      :items="allFilterNames"
                      chips
                      deletable-chips
                      clearable
                      label="Esc för att stänga..."
                      multiple
                      outlined
                      dense
                      prepend-icon="mdi-filter-variant"
                      solo
                      :menu-props="{ y: 'below', offsetY: true }"
                    ></v-select>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      v-if="tab === 1"
                      v-model="startDate"
                      label="Startdatum"
                      type="date"
                      outlined
                      dense
                      clearable
                      @click:clear="startDate = ''"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      v-if="tab === 1"
                      v-model="endDate"
                      label="Slutdatum"
                      type="date"
                      outlined
                      dense
                      clearable
                      @click:clear="endDate = ''"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-btn
                  color="primary"
                  class="ml-10"
                  :disabled="waiting"
                  @click="filterChoosen"
                >
                  Uppdatera graf
                </v-btn>
                <v-btn
                  color="primary"
                  class="ml-10"
                  :disabled="waiting"
                  @click="makeRespondentMessage = !makeRespondentMessage"
                >
                  Skicka återkoppling...
                </v-btn>
                <RespondentFeedbackDialog
                  v-model="makeRespondentMessage"
                  :survey="currentSurveyInstance"
                  :graphs="surveyInstanceReports"
                  :repeatReports="fetchedReports"
                  :start_at="startDate"
                  :end_at="endDate"
                  @send="sendSurveyFeedbackToRespondents"
                />

                <v-divider class="mb-5"></v-divider>
              </div>

              <!-- ====[The Graphs area]============================= -->
              <v-card
                class="d-flex align-stretch flex-wrap"
                color="grey lighten-2"
                flat
                tile
                min-height="200"
              >
                <!-- ====[One Card for Each Graph]=================== -->
                <template v-if="(currentSurveyInstance?.nbr_of_repetitions ?? 0) <= 0">
                  <v-card
                    v-for="(quest, index2) in surveyInstanceReports"
                    :key="index2"
                    class="pa-2"
                    outlined
                    title
                    width="50%"
                  >
                    <!-- ====[Graph Header]============================ -->
                    <h3 class="ma-4">
                      {{ quest.metadata.sequence_nbr }}.
                      {{ quest.barchart.bar_options.chart.id }}
                    </h3>
                    <h6 v-if="/^\d{4}-\d{2}-\d{2}$/.test(fetchedStartDate)" class="ma-4">
                      <I>{{ fetchedStartDate }} - {{ fetchedEndDate }}</I>
                    </h6>
                    <div>
                      <!-- ====[The Bar-Graph]========================= -->
                      <ApexChart
                        width="500"
                        type="bar"
                        :options="barOptionsNumbers(quest)"
                        :series="quest.barchart.bar_series"
                      ></ApexChart>
                      <!-- quest.report.barchart.bar_options"  -->
                      <!-- ====[The Bar-Graph Legends]================= -->
                      <div v-if="quest.showLegend">
                        <div
                          class="text-h7"
                          v-for="(textLegend, index3) in quest.barchart.bar_options.xaxis
                            .categories"
                          :key="index3"
                        >
                          {{ index3 + 1 }}. {{ textLegend }}
                        </div>
                        <p></p>
                      </div>
                      <!-- ====[The Bar-Graph Meta info]=============== -->
                      <h4>
                        Antal besvarade
                        {{ quest.metadata.nbr_of_respondent_answers }} /
                        {{ quest.metadata.total_nbr_of_respondents }}
                      </h4>
                    </div>
                  </v-card>
                </template>
                <template v-else>
                  <!--                     v-for="(quest, index2) in surveyInstanceReports" -->
                  <SurveyCharts :reports="fetchedReports" />
                </template>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SurveysInstancesTable from "../components/SurveysInstancesTable.vue";
import SurveysInstancesTableLinear from "../components/SurveysInstancesTableLinear.vue";
import hshApi from "../services/hshapi";
import RespondentFeedbackDialog from "@/components/RespondentFeedbackDialog.vue";
import SurveyCharts from "@/components/SurveyCharts.vue";

export default {
  components: {
    SurveysInstancesTable,
    SurveysInstancesTableLinear,
    RespondentFeedbackDialog,
    SurveyCharts,
  },
  data: function () {
    return {
      tab: 0, // aktiv tab (0 = första)
      currentSurveyInstance: {},
      surveyInstanceReports: [],
      fetchedReports: [],
      reportToShow: false,
      item: {},
      updatingGraph: false,
      // Filter associated variables
      allFilters: [],
      allFilterNames: [],
      filterToUse: [],
      // Profiling
      loading: false,
      startTime: 0,
      profileName: "",
      makeRespondentMessage: false,
      textvalue: "",
      startDate: "",
      endDate: "",
      fetchedStartDate: "",
      fetchedEndDate: "",
      yAxisMin: 1,
      yAxisMax: 5,
      yAxisLevels: {
        1: "Mycket dålig",
        2: "Ganska dålig",
        3: "Neutral",
        4: "Ganska bra",
        5: "Mycket bra",
      },
    };
  },

  async beforeMount() {
    await this.$store.dispatch("fetchSurveys");
    this.$store.dispatch("fetchQuestions");
  },

  async mounted() {
    // this.$root.$off("surveysInstanceTable-survey-clicked");
    // this.$root.$on("surveysInstanceTable-survey-clicked", (item) => {
    //   this.reportToShow = false;
    //   console.log("Report: SurveyInstance received:" + item.name, item);
    //   this.getReportBelongingToCurrentSurveysInstance(item);
    // });
    this.allFilters = await this.hshFetchFilter();
    this.allFilterNames = this.allFilters.map((m) => m.name);
    console.log(
      "Report mounted: SurveyInstance hshFetchFilter:",
      this.allFilters,
      this.allFilterNames
    );
  },

  computed: {
    waiting: function () {
      return this.updatingGraph;
    },
  },

  methods: {
    onTabChanged(newVal) {
      console.log("Vald tab index:", newVal);
      // Här kan du trigga din logik beroende på vald tab
    },
    surveInstanceChoosen(item) {
      this.reportToShow = false;
      console.log("Report: surveInstanceChoosen received:" + item.name, item);
      this.getReportBelongingToCurrentSurveysInstance(item, this.startDate, this.endDate);
    },
    startProfiling(name) {
      this.profileName = name;
      this.startTime = new Date();
    },

    stopProfiling() {
      var timeDiffMilliseconds = new Date() - this.startTime;
      console.log(
        "Elapsed time for " + this.profileName + ": " + timeDiffMilliseconds + " ms"
      );
    },

    getMaxTextLength(arrayOfText) {
      return Math.max(...arrayOfText.map((o) => o.length));
    },

    showLegend(barOptions) {
      const maxTextLength = this.getMaxTextLength(barOptions.xaxis.categories);
      return maxTextLength >= 23;
    },

    createArrayOfIntegers(length) {
      return Array(length)
        .fill()
        .map((_, i) => i + 1);
    },

    barOptionsNumbers(quest) {
      let barOptions = quest.barchart.bar_options;
      quest.showLegend = this.showLegend(barOptions);
      if (quest.showLegend) {
        let nbrOfCategories = barOptions.xaxis.categories.length;
        barOptions = JSON.parse(JSON.stringify(barOptions));
        barOptions.xaxis.categories = this.createArrayOfIntegers(nbrOfCategories);
      }
      console.log("barOptionsNumbers", barOptions);
      return barOptions;
    },

    async getReportBelongingToCurrentSurveysInstance(itemobj, startDate, endDate) {
      this.updatingGraph = true;
      this.currentSurveyInstance = JSON.parse(JSON.stringify(itemobj));
      const thisIsATableGraph =
        (this.currentSurveyInstance?.nbr_of_repetitions ?? 0) <= 0;
      console.log(
        "getReportBelongingToCurrentSurveysInstance startObject",
        this.currentSurveyInstance,
        thisIsATableGraph,
        startDate
      );

      let reports;
      if (thisIsATableGraph === true) {
        // We have a table graph
        try {
          this.startProfiling("GetReport");
          const surveyInstances = this.$store.getters.getSurveysInstances.filter(
            (i) => i.id == parseInt(this.currentSurveyInstance.id)
          );
          console.log(
            "currentSurveyInstance",
            surveyInstances,
            this.currentSurveyInstance,
            surveyInstances[0].passively
          );
          if (surveyInstances[0].passively) {
            reports = await hshApi.fetchReportPassively(
              this.currentSurveyInstance.id,
              0,
              this.filterToUse,
              startDate,
              endDate
            );
          } else {
            reports = await hshApi.fetchReport(
              this.currentSurveyInstance.id,
              0,
              this.filterToUse,
              startDate,
              endDate
            );
          }
          this.surveyInstanceReports = reports.data;
          this.fetchedStartDate = startDate;
          this.fetchedEndDate = endDate;
        } catch (error) {
          if (error.response.status != 404) {
            console.error("getReportBelongingToCurrentSurveysInstance dispatch", error);
            this.allFilters = [];
            this.allFilterNames = [];
            this.filterToUse = [];
            this.surveyInstanceReports = [];
            this.fetchedStartDate = "";
            this.fetchedEndDate = "";
          }
        } finally {
          this.stopProfiling();
          console.log("Reports:", this.surveyInstanceReports);
        }
        this.surveyInstanceReports = reports.data;
      } else {
        // This is a linear graph
        this.startProfiling("GetReport");
        console.log("Now linear graph ");
        try {
          reports = await hshApi.fetchReportRepeat(
            this.currentSurveyInstance.id,
            0,
            this.filterToUse,
            startDate,
            endDate
          );
          this.fetchedStartDate = startDate;
          this.fetchedEndDate = endDate;
        } catch (error) {
          if (error.response.status != 404) {
            console.error("getReportBelongingToCurrentSurveysInstance dispatch", error);
            this.allFilters = [];
            this.allFilterNames = [];
            this.filterToUse = [];
            this.surveyInstanceReports = [];
            this.fetchedStartDate = "";
            this.fetchedEndDate = "";
          }
        } finally {
          this.stopProfiling();
        }

        // Fix the data
        // printPretty(reports.data);
        this.fetchedReports = reports.data;
        console.log("Reports:", this.fetchedReports, this.chartModels);
      }

      this.updatingGraph = false;
      console.log("his.surtveyInstanceReports", this.surveyInstanceReports);
      this.reportToShow = true;
    },

    async filterChoosen() {
      console.log("filterChoosen", this.filterToUse, this.startDate);
      const res = await this.getReportBelongingToCurrentSurveysInstance(
        this.currentSurveyInstance,
        this.startDate,
        this.endDate
      );
      console.log("filterChoosen res", res);
    },

    // sendSurveyFeedbackToRespondents() {
    //   console.log("sendSurveyFeedbackToRespondents", this.textvalue);
    //   this.makeRespondentMessage = false;
    // },
    // sendSurveyFeedbackToRespondents(payload) {
    //   console.log("Meddelande:", payload.message);
    //   console.log("Grafer som ska ingå:", payload.includedGraphs);
    //   console.log("Index som användaren valt bort:", payload.excludedIndices);

    //   // TODO: Gör REST-anrop här
    // },
    async sendSurveyFeedbackToRespondents(payload) {
      console.log("sendSurveyFeedbackToRespondents :", payload);

      const reportData = {
        ...payload,
      };

      console.log("sendSurveyFeedbackToRespondents Report data=", reportData);

      try {
        const response = await hshApi.postSurveyFeedbackReport(reportData);
        //const response = []; // await axios.post('/api/feedback-report', reportData)
        console.log("Feedback skickad:", response.data);
        this.$dialog.notify.success("Rapporten har skickats!");
      } catch (error) {
        console.error("Fel vid sändning:", error);
        await this.$dialog.error({
          text: `"Kunde inte skicka rapporten"(${error.message} - ${error.response.data})`,
          title: `Varning!`,
          actions: {
            ok: {
              text: "OK",
              color: "blue darken-1",
              handle: () => {
                return undefined;
              },
            },
          },
        });
      }
    },

    async fetchCsvFile() {
      console.log("fetchCsvFile", this.id);
      try {
        const response = await hshApi.getSurveyInstanceCvs(this.currentSurveyInstance.id);
        const html = response.data;
        const blob = new Blob([html], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.currentSurveyInstance.name}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  float: left;
  margin-right: 10px;
  margin-left: 10px;
}
.spinner {
  color: blue;
  margin-left: 45%;
  margin-top: 20px;
}
.charts {
  display: grid;
  grid-gap: 1.5rem;
}
</style>
